import { trackCardHover } from "../../../../modules/core/tracking";

const deltaDays = 1000 * 60 * 60 * 24 * 4;

const ATTRS = ['class', 'data-publicationdate'];

export class ReplyCardHTMLElement extends HTMLElement {
    private cardInteractionTimeout: any

    static get observedAttributes(): string[] {
        return ATTRS;
    }

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (!ATTRS.includes(name) || oldValue === newValue) {
            return;
        }

        if (this.classList.contains('card-wall-release')) {

            const publicationDate = Number(this.dataset.publicationdate);
            const today = Date.now();
    
            if (publicationDate > today - deltaDays) {
                this.classList.add('fresh-release');
            }
        }

        if (this.classList.toString().includes('card-info-slider-1-1-icon')) {
            this.addEventListener('mouseover', this.mouseOverTracker)
        }
    }

    private mouseOverTracker = () => {
        clearTimeout(this.cardInteractionTimeout)
        this.cardInteractionTimeout = setTimeout(() =>
            trackCardHover(this)
        , 3000)
        this.onmouseout = this.mouseOutTracker;
    }

    private mouseOutTracker = () => {
        clearTimeout(this.cardInteractionTimeout)
        this.onmouseout = undefined;
    }
}